import { Modal } from '@components/index';
import { getCustomerSelector } from '@modules/customer/core/selectors';
import { getCurrencyCodeSelector } from '@modules/subscriptions/core/selectors';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

/**
 * One-off migration notice for customers still tagged `Recharge`.
 *
 * The step-by-step paragraph walks the reader through the UI by naming four
 * controls, so those names are interpolated from the very keys those controls
 * render — `MENU.PROFILE`, `PAYMENT.METHODS_HEADING`, `ORDERS.ACTIONS.EDIT` and
 * `PAYMENT.SEND_ME_EMAIL`. Spelling them out in the message would let the
 * instructions drift from the buttons, which is exactly what had already happened
 * in German: the text said "Sende mir Email" while the button read "Sende mir
 * eine E-Mail".
 *
 * The sign-off is two staff names and is not translated.
 */
export const CustomerTag = () => {
  const intl = useIntl();
  const customer = useSelector(getCustomerSelector);
  const currencyCode = useSelector(getCurrencyCodeSelector);

  const [isModalVisible, setIsModalVisible] = useState(true);

  const handleClose = () => setIsModalVisible(false);
  if (!customer?.tags?.includes('Recharge')) return null;

  return (
    <div className="row gy-5 g-xl-8">
      <div className="mb-20">
        <Modal isOpen={isModalVisible} handleClose={handleClose}>
          <div className="flex justify-center text-3xl">
            <div className="xl:p-[10rem] py-[5rem] px-[2rem] text-[2.4rem] leading-[1.4]">
              <p className="mb-4">
                <FormattedMessage
                  id="MIGRATION.NEW_PORTAL"
                  values={{
                    strong: (chunks) => <span className="font-bold text-center">{chunks}</span>,
                  }}
                />
              </p>
              <p className="mb-4">
                <FormattedMessage
                  id="MIGRATION.ASK"
                  values={{
                    strong: (chunks) => (
                      <span className="ml-2 font-bold text-center">{chunks}</span>
                    ),
                  }}
                />
              </p>
              <p className="mb-[4]">
                <FormattedMessage
                  id="MIGRATION.HOW_TO"
                  values={{
                    profile: intl.formatMessage({ id: 'MENU.PROFILE' }),
                    paymentMethods: intl.formatMessage({ id: 'PAYMENT.METHODS_HEADING' }),
                    edit: intl.formatMessage({ id: 'ORDERS.ACTIONS.EDIT' }),
                    sendEmail: intl.formatMessage({ id: 'PAYMENT.SEND_ME_EMAIL' }),
                  }}
                />
              </p>
              <br />
              <p>
                <FormattedMessage
                  id="MIGRATION.PAYPAL_NOTE"
                  values={{
                    amount: intl.formatNumber(0.01, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }),
                    currency: currencyCode,
                    b: (chunks) => <b>{chunks}</b>,
                  }}
                />
              </p>
              <br />
              <p>
                {' '}
                <FormattedMessage id="MIGRATION.QUESTIONS" />
              </p>
              <br />
              <FormattedMessage id="MIGRATION.SIGN_OFF" values={{ break: <br /> }} /> <br /> Nadine
              &amp; Christina
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};
